// controllers/design-controller.ts
import "lit";
import { Subject, takeUntil } from "rxjs";
import { DesignSystem } from "../elements/theming/design";
import "./chemistry-controller";
var DesignController = class {
  constructor(host) {
    this.disconnected = new Subject();
    (this.host = host).addController(this);
    const theme = DesignSystem.currentTheme.getValue();
    if (theme) {
      this.host.spacing = theme.spacing;
      this.host.baseFontSize = theme.baseFontSize;
      this.host.baseFontSizePrint = theme.baseFontSizePrint;
      this.host.fontFamily = theme.fontFamily;
      this.host.borders = theme.borders;
      this.host.shadows = theme.shadows;
      this.host.sizes = theme.sizes;
      this.host.colors = theme.colors;
    }
  }
  hostConnected() {
    DesignSystem.currentTheme.pipe(takeUntil(this.disconnected)).subscribe((theme) => {
      this.host.spacing = theme.spacing;
      this.host.baseFontSize = theme.baseFontSize;
      this.host.baseFontSizePrint = theme.baseFontSizePrint;
      this.host.fontFamily = theme.fontFamily;
      this.host.borders = theme.borders;
      this.host.shadows = theme.shadows;
      this.host.sizes = theme.sizes;
      this.host.colors = theme.colors;
      this.host.requestUpdate();
    });
  }
  hostDisconnected() {
    this.disconnected.next();
  }
};
export {
  DesignController
};
